<template>
  <component
    :is="parentModule.config.general.template.component"
    :id="module.id"
    class="benefit"
    :style="benefitElStyles"
  >
    <template v-if="parentModule.config.general.showIcon" #icon>
      <BenefitUIIcon :icon="module.config.icon" />
    </template>

    <template v-if="showHeader(parentModule)" #header>
      <BenefitUIHeader :header="module.config.header" />
    </template>

    <template v-if="parentModule.config.general.showContent" #text>
      <BenefitUIText :text="module.config.text" />
    </template>
  </component>
</template>

<script>
import benefitModule from "./benefitDefaultModuleProp";
import benefitsModule from "../Benefits/benefitsDefaultModuleProp";

import BenefitUIText from "../UI/BenefitUIText.vue";
import BenefitUIHeader from "../UI/BenefitUIHeader.vue";
import BenefitUIIcon from "../UI/BenefitUIIcon.vue";

import BenefitCube from "../Templates/BenefitCube.vue";
import { globalMethods } from "../../GlobalUI/mixins/global.js";

export default {
  name: "Benefit",
  components: {
    BenefitCube,
    BenefitUIText,
    BenefitUIHeader,
    BenefitUIIcon,
  },
  mixins: [globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return benefitModule;
      },
    },
    parentModule: {
      type: Object,
      default() {
        return benefitsModule;
      },
    },
  },
  computed: {
    benefitElStyles() {
      const { benefitBackgroundColor, corners } =
        this.parentModule.config.general;

      const styles = {
        borderRadius: corners.value === "round" ? "20px" : "0px",
        backgroundColor: benefitBackgroundColor.value,
      };

      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.benefit {
  display: flex;
  width: 388px;
  padding: 28px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
</style>
